import {Navbar, Nav, Container } from 'react-bootstrap';
import {Button } from 'react-bootstrap';

export const NavBar = () => {
  return (
      <Navbar expand="lg" bg="dark" data-bs-theme="dark">
        <Container fluid>
          <Navbar.Brand href="#home">
          <h3>Portfolio.</h3>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav">
          </Navbar.Toggle >
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="#About Me">About Me</Nav.Link>
              <Nav.Link href="#Projects">Projects</Nav.Link>
              <Nav.Link href="#Resume">Resume</Nav.Link>
              <Nav.Link href="#Extras">Extras</Nav.Link>
            </Nav>
            <Button className='Nav.Link' href="#Contact" variant="outline-info">Let's Connect</Button>
          </Navbar.Collapse>     
        </Container>
      </Navbar>
    );
}